var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.868 23.868",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.971 16.143-7.0366 3.3381-7.0366-3.3381-4.8976 2.064 11.934 5.6615 11.934-5.6615z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.513 15.107 7.3551-3.4892-4.8976-2.064-7.0366 3.3381-7.0366-3.3381-4.8976 2.064 11.934 5.6614z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.3551 8.5186 4.5791 2.1723 11.934-5.6615-11.934-5.0294-11.934 5.0294 4.9456 2.3461z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiers);
export default __webpack_public_path__ + "static/media/tiers.1c816de983e51d21acc292082c15b1cd.svg";
export { ForwardRef as ReactComponent };